export default "__VITE_ASSET__DNH4M3eG__"